export default "__VITE_ASSET__BR4X_eev__"